export default __webpack_public_path__ + "static/media/project-status-closed.a3bb1927.svg";